<template>
  <div>
    <h4>Account Details</h4>
    <div v-if="user.name">Nanome ID: {{ user.name }}</div>
    <div v-if="user.email">Email: {{ user.email }}</div>
    <div v-if="user.tfa_enabled">
      <i class="fa fa-lock mr-1"></i> 2FA Enabled
    </div>
    <div class="mt-2">
      <b-link :to="{ name: 'Account' }" gtm-info="home-manage_account">
        <i class="icon-pencil"></i>
        Manage Account
      </b-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"])
  }
};
</script>
